import Query from '../../../../../components/Report';

export const query = ({ prompt_uids = [], platforms = '' }) =>
    new Query('ai-tracking-share-of-voice', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
    });

function setKeywordUids(ids) {
    return `r.prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and r.platform in (${platforms.map((item) => `'${item}'`)})`;
}
